import { render, staticRenderFns } from "./MultiStepLoader.vue?vue&type=template&id=2720e380&scoped=true"
import script from "./MultiStepLoader.vue?vue&type=script&lang=js"
export * from "./MultiStepLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2720e380",
  null
  
)

export default component.exports